export default __webpack_public_path__ + "static/media/Kiunalla6.9abc0a6e.jpg";